import { render, staticRenderFns } from "./GearIcon.vue?vue&type=template&id=5b57b982&scoped=true&"
import script from "./GearIcon.vue?vue&type=script&lang=js&"
export * from "./GearIcon.vue?vue&type=script&lang=js&"
import style0 from "./GearIcon.vue?vue&type=style&index=0&id=5b57b982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57b982",
  null
  
)

export default component.exports